import React from 'react'
import PropTypes from 'prop-types'

import useRect from '../hooks/useRect'

import { PROPTYPES_RECT } from './constants'

// TODO: this component is weird, improve it.
// It requires that others tell it what is their size...

const Align = (props) => {
  const { children, childrenRect, x, y } = props
  const [Rect, rect] = useRect()

  const positionX = {
    center: {
      x: rect.width / 2 - childrenRect.width / 2,
    },
    left: {
      x: 0,
    },
    right: {
      x: rect.width - childrenRect.width,
    },
  }
  const positionY = {
    center: {
      y: rect.height / 2 - childrenRect.height / 2,
    },
    top: {
      y: 0,
    },
    bottom: {
      y: rect.height - childrenRect.height,
    },
  }

  return (
    <>
      <Rect />
      <svg
        className="ai-slide__align"
        {...positionX[x]}
        {...positionY[y]}
        width={childrenRect.width || '100%'}
        height={childrenRect.height}
      >
        {children}
      </svg>
    </>
  )
}

Align.propTypes = {
  children: PropTypes.node.isRequired,
  childrenRect: PropTypes.shape(PROPTYPES_RECT).isRequired,
  x: PropTypes.string,
  y: PropTypes.string,
}

Align.defaultProps = {
  x: 'center',
  y: 'center',
}

export default Align
